define.alias("ember-math-helpers/helpers/max", "media/helpers/max");